import { AlertsHeadline } from '@store';

import { OverlayType, ZoomPreset } from '../../components/map/Map';

export const showAlerts = (
  overlayType: keyof typeof OverlayType,
  zoomPreset: keyof typeof ZoomPreset,
  alerts: AlertsHeadline[],
) => alerts && alerts.length > 0 && overlayType === OverlayType.radar && zoomPreset === ZoomPreset.local;
